import React, { useEffect, useState } from "react";
import { Button, Form, Row } from "react-bootstrap";
import { FaMinus, FaTrashAlt } from "react-icons/fa";

const ClinicFollowupForm = ({ followupItem, clinicId }) => {
  const [updatedFollowupLabel, setUpdatedFollowupLabel] = useState(
    followupItem.label,
  );
  const [lowerLimit, setLowerLimit] = useState(followupItem.lowerLimit);
  const [upperLimit, setUpperLimit] = useState(followupItem.upperLimit);
  const [isHide, setIsHide] = useState(followupItem.isHide);

  const deleteFollowupdItem = () => {
    if (window.confirm("You will delete this service. Are you sure?")) {
      setIsHide(true);
    }
  };

  useEffect(() => {
    followupItem.label = updatedFollowupLabel;
    followupItem.lowerLimit = lowerLimit;
    followupItem.upperLimit = upperLimit;
    followupItem.isHide = isHide;
  }, [updatedFollowupLabel, isHide, lowerLimit, upperLimit]);
  return (
    <>
      {!isHide && (
        <Row>
          <Form.Group className="col-6">
            <Form.Control
              type="text"
              className="w-100"
              placeholder="type your follow-up here"
              value={updatedFollowupLabel}
              onChange={(e) => setUpdatedFollowupLabel(e.target.value)}
              isValid={updatedFollowupLabel}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="col-2">
            <Form.Control
              type="number"
              className="w-100"
              value={upperLimit}
              onChange={(e) => setUpperLimit(e.target.value)}
              isValid={upperLimit}
            ></Form.Control>
          </Form.Group>
          <Form.Group className="col-2">
            <Form.Control
              type="number"
              className="w-100"
              value={lowerLimit}
              onChange={(e) => setLowerLimit(e.target.value)}
              isValid={lowerLimit}
            ></Form.Control>
          </Form.Group>

          <Form.Group className="col-2 align-self-end text-center">
            <Button
              className="btn btn-danger"
              onClick={() => deleteFollowupdItem(followupItem)}
            >
              <FaTrashAlt />
            </Button>
          </Form.Group>
        </Row>
      )}
    </>
  );
};

export default ClinicFollowupForm;
